export default "__VITE_ASSET__ce878632__"